export const styleConstants = {
  buttonBorderRadius: '4px',
  inputBorderRadius: '4px',
  inputLabelOffset: '-3px',
  leftArrowButtonPadding: '8px',
  dotsButtonPadding: '8px',
};
